import React from 'react';

interface ActionButtonProps {
  title: string;
  description: string | React.ReactNode;
  icon?: React.ReactNode;
  onClick: () => void;
  index?: number;
}

const ActionButton = ({ title, description, icon, onClick, index }: ActionButtonProps) => {
  return (
    <button
      className={`flex w-full items-center gap-3 rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all duration-200 hover:cursor-pointer hover:border-blue-200 hover:bg-blue-50/30 hover:shadow-md ${index ? `border-active-${index}` : ''}`}
      onClick={onClick}
    >
      <div className="flex h-8 w-8 items-center justify-center rounded-full border border-gray-200 bg-gray-50">
        {icon}
      </div>
      <div className="text-left">
        <p className="text-sm font-medium text-gray-900">{title}</p>
        <p className="text-xs text-gray-600">{description}</p>
      </div>
    </button>
  );
};

export default ActionButton;
